const dnsSetup = 'dnsSetup';

/** Base Fetch Actions */
export const FETCH_DNS_SETUP_RESPONSE = `${dnsSetup}/FETCH_DNS_SETUP_RESPONSE`;
export const FETCH_DNS_SETUP_REQUEST = `${dnsSetup}/FETCH_DNS_SETUP_REQUEST`;
export const FETCH_DNS_SETUP_ERROR = `${dnsSetup}/FETCH_DNS_SETUP_ERROR`;
